import { axiosIns } from "../utils";

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.q?.trim()) params.set("q", filters.q.trim());
  if (filters.category) params.set("category", filters.category);
  if (filters.stockStatus) params.set("stock_status", filters.stockStatus);
  if (filters.validated === true || filters.validated === "true") {
    params.set("validated", "true");
  }
  if (filters.validated === false || filters.validated === "false") {
    params.set("validated", "false");
  }
  if (filters.startDate) params.set("start_date", filters.startDate);
  if (filters.endDate) params.set("end_date", filters.endDate);
  if (filters.page) params.set("page", filters.page);
  if (filters.pageSize) params.set("page_size", filters.pageSize);

  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export const fetchPromotedProducts = async (filters) => {
  const response = await axiosIns.get(`/promoted-products/${buildQuery(filters)}`);
  return response?.data ?? response;
};

export const fetchPendingProducts = async (filters) => {
  const response = await axiosIns.get(
    `/promoted-products/pending/${buildQuery(filters)}`
  );
  return response?.data ?? response;
};

export const fetchPromotedProduct = async (id) => {
  const response = await axiosIns.get(`/promoted-products/${id}/`);
  return response?.data ?? response;
};

export const createPromotedProductApi = async (payload) => {
  const response = await axiosIns.post("/promoted-products/", payload);
  return response?.data ?? response;
};

export const updatePromotedProductApi = async (id, payload) => {
  const response = await axiosIns.patch(`/promoted-products/${id}/`, payload);
  return response?.data ?? response;
};

export const deletePromotedProductApi = async (id) => {
  const response = await axiosIns.delete(`/promoted-products/${id}/`);
  return response?.data ?? response;
};

export const validatePromotedProductApi = async (id) => {
  const response = await axiosIns.patch(`/promoted-products/${id}/validate/`);
  return response?.data ?? response;
};

export const invalidatePromotedProductApi = async (id, rejectionReason = "") => {
  const response = await axiosIns.patch(`/promoted-products/${id}/invalidate/`, {
    rejection_reason: rejectionReason,
  });
  return response?.data ?? response;
};

export const updatePromotedProductStockApi = async (id, stockQuantity) => {
  const response = await axiosIns.patch(`/promoted-products/${id}/update-stock/`, {
    stock_quantity: stockQuantity,
  });
  return response?.data ?? response;
};

/**
 * Uploads ONE image. Multipart nested-writes are unreliable, so the product is
 * created first in JSON and its images are posted one by one against this
 * endpoint. `onUploadProgress` feeds the per-image progress bar.
 */
export const uploadProductImageApi = async (
  productId,
  { file, isCover = false, position = 0, onUploadProgress } = {}
) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("is_cover", isCover ? "true" : "false");
  formData.append("position", String(position));

  const response = await axiosIns.post(
    `/promoted-products/${productId}/images/`,
    formData,
    { onUploadProgress }
  );
  return response?.data ?? response;
};

export const deleteProductImageApi = async (imageId) => {
  const response = await axiosIns.delete(`/product-images/${imageId}/`);
  return response?.data ?? response;
};

export const setProductImageCoverApi = async (imageId) => {
  const response = await axiosIns.patch(`/product-images/${imageId}/set-cover/`);
  return response?.data ?? response;
};

export const fetchProductCategories = async () => {
  const response = await axiosIns.get("/product-categories/");
  return response?.data ?? response;
};

export const createProductCategoryApi = async (designation) => {
  const response = await axiosIns.post("/product-categories/", { designation });
  return response?.data ?? response;
};

export const updateProductCategoryApi = async (id, designation) => {
  const response = await axiosIns.patch(`/product-categories/${id}/`, {
    designation,
  });
  return response?.data ?? response;
};

export const deleteProductCategoryApi = async (id) => {
  const response = await axiosIns.delete(`/product-categories/${id}/`);
  return response?.data ?? response;
};
